export default __webpack_public_path__ + "static/media/arrow_down.a26dad3e.svg";